import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  max-width: 600px;
  margin: 0 auto;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 12px;
`;

export const Subtitle = styled.p`
  font-size: 16px;
  color: #666;
  line-height: 1.5;
`;

export const SearchSection = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #0066cc;
  }

  &::placeholder {
    color: #999;
  }
`;

export const SectionLabel = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: #666;
  margin-bottom: 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const VendorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 16px;
  width: 100%;
  margin-bottom: 24px;
`;

export const VendorCard = styled.button<{ $selected?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  background: ${(props) => (props.$selected ? "#e6f0ff" : "#fff")};
  border: 2px solid ${(props) => (props.$selected ? "#0066cc" : "#eee")};
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #0066cc;
    background: #f5f9ff;
  }
`;

export const VendorLogo = styled.div`
  width: 48px;
  height: 48px;
  background: #f0f0f0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  overflow: hidden;

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const VendorName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #333;
  text-align: center;
`;

export const VendorList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const VendorListItem = styled.button<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: ${(props) => (props.$selected ? "#e6f0ff" : "#fff")};
  border: 1px solid ${(props) => (props.$selected ? "#0066cc" : "#eee")};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;

  &:hover {
    border-color: #0066cc;
    background: #f5f9ff;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: 24px;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: #0066cc;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: #0052a3;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  width: 100%;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 500;
  color: #666;
  background: transparent;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f5f5f5;
    border-color: #ccc;
  }
`;

export const PrivacyNote = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  padding: 12px 16px;
  background: #f9f9f9;
  border-radius: 8px;
  font-size: 13px;
  color: #666;
`;

export const LockIcon = styled.span`
  font-size: 16px;
`;

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px;
`;

export const ErrorMessage = styled.div`
  padding: 12px 16px;
  background: #fff0f0;
  border: 1px solid #ffcccc;
  border-radius: 8px;
  color: #cc0000;
  margin-bottom: 16px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 24px;
`;

export const SearchIcon = styled.span`
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
`;

export const EmptyStateTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
`;

export const EmptyStateText = styled.p`
  font-size: 15px;
  color: #666;
  line-height: 1.5;
  margin: 0;
`;

// Import Status Page Styles
export const ProgressSection = styled.div`
  width: 100%;
  margin-bottom: 32px;
`;

export const ProgressBar = styled.div<{ $value: number }>`
  width: 100%;
  height: 8px;
  background: #eee;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;

  &::after {
    content: "";
    display: block;
    width: ${(props) => props.$value}%;
    height: 100%;
    background: #0066cc;
    transition: width 0.3s ease;
  }
`;

export const ProgressText = styled.span`
  font-size: 14px;
  color: #666;
`;

export const ImportChecklist = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ChecklistItem = styled.div<{ $required?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: ${(props) => (props.$required === false ? "#fafafa" : "#f9f9f9")};
  border-radius: 8px;
  border-left: ${(props) => (props.$required ? "3px solid #0066cc" : "none")};
`;

export const StatusIcon = styled.span<{ $status: string }>`
  font-size: 18px;
  color: ${(props) =>
    props.$status === "completed"
      ? "#00aa00"
      : props.$status === "loading"
      ? "#0066cc"
      : "#999"};
`;

export const CategoryName = styled.span`
  flex: 1;
  font-size: 15px;
  color: #333;
`;

export const ItemCount = styled.span`
  font-size: 13px;
  color: #666;
  background: #eee;
  padding: 2px 8px;
  border-radius: 4px;
`;

export const ContinueButton = styled(PrimaryButton)`
  margin-top: 32px;
`;
